import React from 'react'

export default () => <>&mdash;</>
